import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientesListComponent } from './clientes-list.component';
import { PoModule } from '@po-ui/ng-components';



@NgModule({
  declarations: [ClientesListComponent],
  imports: [
    CommonModule, PoModule
  ]
})
export class clientesListModule { }
